export const iconFontAwesomeEnergyBatteryThreeQuarters = (
	<i className="fa-solid fa-battery-three-quarters"></i>
);
